"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FORBIDDEN_FILE_ERROR = exports.DEFAULT_FILE_EXTENSIONS = void 0;
var DEFAULT_FILE_EXTENSIONS = exports.DEFAULT_FILE_EXTENSIONS = ['jpg', 'png', 'heic', 'jpeg'];
var FORBIDDEN_FILE_ERROR = exports.FORBIDDEN_FILE_ERROR = 'FORBIDDEN_FILE_ERROR';